/**
 * Factory para realizar el bind del scope para la(s) cabecera(s).
 * Es para crear por ej. scope.CAB
 * Es para que funcione las expressiones etc...
 *
 * @param {object} data - objeto encapsulando los datos, ej: "{CAB: {...}}"
 *
 * @return {function}
 */
export function bindDataFactory(data) {
  return function bindData(scope) {
    Object.assign(scope, data);

    // @odeniel: como data es un objeto que contiene objetos, ej. {CAB:{}}
    // en principio el bind se hace por referencia y no es necesario definir un getter,
    // entonces comento el Object-defineProperty:
    // -ini-
    // Object.keys(data).forEach(model => {
    //   // console.log(`ecFormBuilder "${xPath}" get: scope[${model}] from data (CONFIG?)`)
    //   const isAlreadyExist = scope.hasOwnProperty(model);
    //   if (isAlreadyExist) {
    //     return;
    //   }
    //   Object.defineProperty(scope, model, {
    //     get: () => data[model],
    //   });
    // });
    // -fin-
  };
}
